/* eslint no-undef: off */
import { noop } from 'underscore';
import { logged_in as loggedIn } from 'state';
import { bootSeo } from 'booters';

export default (getMetaInfoFn) => {
  if (loggedIn()) return;

  const path = window.location.pathname;

  Promise.all([getMetaInfoFn(), bootSeo()]).then(([metaInfo]) => {
    if (metaInfo && path === window.location.pathname) {
      reduxState.store.actionDispatchers.seo.setMetaInfo({
        ...metaInfo,
        path,
      });
    }
  }).catch(noop);
};
